<!--
 * @Author: wuzuojie 15727841808@163.com
 * @Date: 2023-07-26 10:50:42
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-13 13:57:34
 * @FilePath: /chaoyongtuan/src/views/secondColonelManage/cooperativeColonel/detail/components/contactTab/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="contact-tab">
		<div class="flex flex-align-center" v-if="$auth.hasPermi('system:cooperativeColonel:addConnection')">
			<el-button type="primary" plain @click="showContactDialog(id, true)">新建联系人</el-button>
			<div class="fz-14 yx-color-info ml-16">
				<span>共 </span>
				<span class="yx-color-text-primary font-bold">{{ total }}</span>
				<span> 个联系人</span>
			</div>
		</div>
		<multi-table
			v-show="total"
			ref="multiTable"
			:distanceTop="0"
			:pageFixed="false"
			:columns="columns"
			@gePartnerList="gePartnerList"
			:list="list"
			:total="total"
			v-loading="loading"
		>
		</multi-table>
		<div class="align-center" style="margin-top: 150px" v-if="total == 0">
			<div class="i-empty"></div>
			<div class="yx-color-info">暂无数据</div>
		</div>
		<contact-dialog ref="contactDialog" @getList="getInfo" />
	</div>
</template>

<script>
import { columns } from './columns.js';
import contactDialog from '@/views/secondColonelManage/cooperativeColonel/components/contactDialog';
import { getInstitutionContactList } from '@/api/secondColonelManage';

export default {
	name: 'contactTab',
	components: {
		contactDialog,
	},
	props: {
		id: {
			type: [String, Number],
			default: 0,
		},
	},
	data() {
		return {
			list: [],
			total: 0,
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			loading: false,
			columns,
		};
	},
	methods: {
		async getInfo() {
			this.loading = true;
			try {
				const { pageInfo, id: team_institution_id } = this;
				const { code, data: { list = [], page = {} } = {} } = await getInstitutionContactList({ ...pageInfo, team_institution_id });
				if (code !== 0) return;
				this.list = list.map(item => {
					return {
						...item,
						operations: this.getButtons(item),
					};
				});
				this.total = page.item_total;
			} finally {
				this.loading = false;
			}
		},
		getButtons(item) {
			const arr = [
				{
					label: '修改',
					type: 'text',
					classType: 2,
					isShow: true,
					click: row => {
						this.showContactDialog(row, false);
					},
				},
			];
			return arr.filter(item => item.isShow);
		},
		gePartnerList({ page_index, page_size }) {
			this.pageInfo.page_index = page_index;
			this.pageInfo.page_size = page_size;
			this.getInfo();
		},
		showContactDialog(data, isAdd) {
			this.$refs.contactDialog.show(data, isAdd);
		},
	},
};
</script>

<style lang="less" scoped>
.contact-tab {
	margin-top: 10px;
}
</style>
